<div class="map-schema-diagram">
  <div class="map-schema-diagram-canvas">
    <lib-gojs-schematic
      [substationId]="selectedSubstationId"
      [substationName]="selectedSubstation?.name ?? null"
      [viewOnly]="true"
      [showSchemaAssetPicker]="true"
    >
      <app-schema-asset-picker
        schematicHeaderLeft
        [templates]="templateOptions"
        [substations]="substationOptions"
        [selectedTemplate]="selectedTemplate"
        [selectedSubstation]="selectedSubstation"
        (templateSelected)="onTemplateSelected($event)"
        (substationSelected)="onSubstationSelected($event)"
        (searchChange)="onSubstationFilterChange($event)"
      ></app-schema-asset-picker>
    </lib-gojs-schematic>

    <div *ngIf="!loading && noPublishedSchemas" class="map-schema-diagram-empty">
      No substation has a published schema diagram yet.
    </div>
  </div>
</div>
